import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';

import { withTranslation } from '@wix/yoshi-flow-editor';
import { LinkButton } from '../buttons/buttons';
import { logOutCurrentMember } from '../../utils/auth';

import styles from './logout-link.scss';

const mapStateToProps = null;
const mapDispatchToProps = { logOutCurrentMember };

const LogOutLink = connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  class LogOutLink extends React.Component {
    static propTypes = {
      prefix: PropTypes.node,
      onLogout: PropTypes.func.isRequired,
      className: PropTypes.string,
    };

    logOut = () => {
      this.props.onLogout();
      this.props.logOutCurrentMember();
    };

    renderLink() {
      const { className } = this.props;

      return (
        <LinkButton
          className={classnames(styles.link, className)}
          dataHook="logout-button"
          ariaLabel={this.props.t('widget.account.logout')}
          onClick={this.logOut}
        >
          {this.props.t('widget.account.logout')}
        </LinkButton>
      );
    }

    render() {
      const { prefix } = this.props;

      if (prefix) {
        return (
          <div className={styles.withPrefix}>
            {prefix} {this.renderLink()}
          </div>
        );
      }

      return this.renderLink();
    }
  },
);

export default withTranslation()(LogOutLink);
